/*eslint-disable no-var, no-unused-labels, import/default, import/namespace, import/no-named-as-default, import/no-named-as-default-member, react/no-did-mount-set-state, react/no-did-update-set-state */
import React from 'react';
import update from 'react-addons-update';
import classNames from 'classnames';
import Score from './Score';
import Overview from './Overview';
import Stats from './Stats';
import Tips from './Tips';
import Suggestions from './Suggestions';
import Banner from './Banner';
import Actions from './Actions';
import {processStats} from '../../utils/calculator';
import stats from '../../data/results.json';

class ResultsStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showActions: false,
      stats: processStats(props.results),
      status: 0
    };
  }

  componentDidMount() {
    this.setState({status: 1});
    setTimeout(() => {
      this.setState({showActions: true});
    }, 500);
  }

  componentDidUpdate() {
    if(this.state.status === 1) {
      setTimeout(() => {
        this.setState({status: 2});
      }, 500);
    }
  }

  render() {
    const {version, id, answers} = this.props;
    const {stats, status, showActions} = this.state;
    const onNetlify = stats.on_netlify.value;
    const actionsState = showActions ? 'visible' : 'hidden';
    const isBroken = stats.complete_load.value === 0;
    const className = classNames(
      'results',
      { [`is-status-${status}`]: true },
      { [`is-actions-${actionsState}`]: true },
      { [`is-version-${version}`]: true },
      { 'is-on-netlify': onNetlify },
      { 'is-broken': isBroken}
    );

    return (
      <div className={className}>
        <div className="results__header">
          <div className="results__header__main">
            <Score stats={stats} status={status} isBroken={isBroken} />
          </div>
          <div className="results__header__secondary">
            <Overview stats={stats} isBroken={isBroken}/>
          </div>
        </div>
        {isBroken ? null : <Stats stats={stats} version={version} />}
        {!(onNetlify || isBroken) ? <Suggestions stats={stats} answers={answers} /> : ''}
        {!(onNetlify || isBroken) ? <Tips stats={stats} answers={answers} /> : ''}
        {!(onNetlify || isBroken) ? <Banner /> : ''}
      </div>
    );
  }
}

ResultsStep.propTypes = {
  answers: React.PropTypes.object.isRequired,
  results: React.PropTypes.object.isRequired,
  version: React.PropTypes.string,
  id: React.PropTypes.string
};

ResultsStep.defaultProps = {
  version: 'a'
};

export default ResultsStep;



// WEBPACK FOOTER //
// ./src/components/results/ResultsStep.js